import { CommunityAdapter as CoreCommunityAdapter } from '@core/adapters';
// import {
//   FetchNewMainBannersPayload,
//   FetchNewMainBannersResponse,
//   FetchNewMainBoardsPayload,
//   FetchNewMainBoardsResponse,
// } from '@core/dto';
// import { CommonApiEndpoint } from '@core/api-endpoint';

export class CommunityAdapter extends CoreCommunityAdapter {}
// async fetchNewMainBoards(payload?: FetchNewMainBoardsPayload): Promise<any> {
//   try {
//     const response = await this.http.get<FetchNewMainBoardsResponse>(
//       CommonApiEndpoint.fetchMainBoards,
//       payload || {}
//     );
//     return response.data;
//   } catch (error) {
//     return {};
//   }
// }
// async fetchNewMainBanners(
//   payload?: FetchNewMainBannersPayload
// ): Promise<any> {
//   try {
//     const response = await this.http.get<FetchNewMainBannersResponse>(
//       CommonApiEndpoint.fetchMainBanners,
//       payload || {}
//     );
//     return response.data;
//   } catch (error) {
//     return {};
//   }
// }
